var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "nav-logo flex-center padding-right-10 position-relative",
      },
      [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("@/static/yd-logo-active.png") },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }